<div [class]="wrapperClass">
  <div class="pointer-events-none" [class]="ringClass" aria-hidden="true"></div>
  @if (label) {
    <span class="text-sm text-gray-500 dark:text-gray-400">{{ label }}</span>
  }
</div>
